import { useCallback, useEffect } from 'react';
import { BUS_EVENT_NAME } from '../../FrontEndReact/src/Core/Contexts/eventContext';
import { AdminState, GlobalStateProvider } from '../../FrontEndReact/src/Core/Contexts/globalStateContext';
import { reInitializeLegacy, SetSelectedCulture } from '../../AdminMetronic/Js/Common/Services/legacy';

const REACT_BUS_EVENT_NAME = `react:${BUS_EVENT_NAME}`;
const NG_BUS_EVENT_NAME = `ng:${BUS_EVENT_NAME}`;

const transformEventForLegacy = (type: string, payload?: unknown) => {
	// add any transformation logic needed for legacy compatibility
	// if (type === 'SOMETHING') {
	// 	return {
	// 		type: 'SOMETHING_ELSE',
	// 		payload,
	// 	};
	// }
	return { type, payload };
};

const transformEventFromLegacy = (type: string, payload?: unknown) => {
	// add any transformation logic needed for legacy compatibility
	// if (type === 'SOMETHING_ELSE') {
	// 	return {
	// 		type: 'SOMETHING',
	// 		payload,
	// 	};
	// }
	return { type, payload };
};

const autoHandleReactEvent = (type: string, payload?: unknown) => {
	if (type === 'adminStateChanged' && typeof payload === 'object' && payload !== null) {
		const newAdminState = payload as Partial<AdminState>;
		if (newAdminState.selectedCulture) {
			SetSelectedCulture(newAdminState.selectedCulture);
			return true;
		}
	} else if (type === 'REINITIALIZE') {
		reInitializeLegacy();
		return true;
	}
	return false;
};

type LegacyEventBridgeProps = {
	children: React.ReactNode;
	routingBasePath?: string;
	initialAdminState?: AdminState;
};

const LegacyEventBridge = ({ children, routingBasePath, initialAdminState }: LegacyEventBridgeProps) => {
	// React → AngularJS: dispatch on prefixed event name so AngularJS relay can pick it up
	const customDispatch = useCallback((type: string, payload?: unknown) => {
		if (autoHandleReactEvent(type, payload)) {
			return;
		}
		window.dispatchEvent(new CustomEvent(REACT_BUS_EVENT_NAME, { detail: transformEventForLegacy(type, payload) }));
	}, []);

	// AngularJS → React: listen for prefixed AngularJS events and re-dispatch as internal bus events
	useEffect(() => {
		const handler = ((event: CustomEvent) => {
			const detail = event.detail;
			if (typeof detail === 'object' && detail !== null && 'type' in detail) {
				const transformed = transformEventFromLegacy(detail.type, detail.payload);
				console.log('Received event from AngularJS:', transformed.type, transformed.payload);
				window.dispatchEvent(new CustomEvent(BUS_EVENT_NAME, { detail: transformed }));
			}
		}) as EventListener;

		window.addEventListener(NG_BUS_EVENT_NAME, handler);
		return () => window.removeEventListener(NG_BUS_EVENT_NAME, handler);
	}, []);

	return (
		<GlobalStateProvider
			legacy={true}
			routingBasePath={routingBasePath}
			customDispatch={customDispatch}
			initialAdminState={initialAdminState}
		>
			{children}
		</GlobalStateProvider>
	);
};

export default LegacyEventBridge;
